import { render, staticRenderFns } from "./i-msg-tab.vue?vue&type=template&id=af71eefa"
import script from "./i-msg-tab.vue?vue&type=script&lang=js"
export * from "./i-msg-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports